import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import AbstractDropdown from '../../../AbstractDropdown';
import Selector from '../../Common/Selector';

import { Templates as ChooseTemplatesIcon } from '@icons/crm';
import { TicketTemplateOptionType } from '../types';

interface ITicketTemplateSelector {
  className?: string;
  options: TicketTemplateOptionType[];
  value?: string;
  onChange: (template: TicketTemplateOptionType) => void;
}

const TicketTemplateSelector = (props: ITicketTemplateSelector) => {
  const [closedState, toggleCloser] = useState<number>();

  const handleChangeItem = useMemo(() => {
    return ev => {
      toggleCloser(Date.now());
      props.onChange(ev);
    };
  }, [props]);

  const headRenderer = useMemo(
    () => () => <ChooseTemplatesIcon width={15} height={15} />,
    []
  );
  const contentRenderer = useMemo(
    () => () =>
      (
        <StyledTemplatesSelector
          {...props}
          menuIsOpen
          components={{
            Control: () => null,
          }}
          onChange={handleChangeItem}
        />
      ),
    [props]
  );

  return (
    <StyledAbstractDropdown
      key={closedState}
      autoClose
      headRenderer={headRenderer}
      contentRenderer={contentRenderer}
    />
  );
};

const StyledAbstractDropdown = styled(AbstractDropdown)`
  position: relative;
  margin-left: auto;
`;

const StyledTemplatesSelector = styled(Selector)`
  width: 260px;
  position: absolute !important;
  right: 0px;
  top: 0;
`;

export default TicketTemplateSelector;
